import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import WaeButton, { BUTTON_VARIANT } from '../../../components/Button';
import theme from '../../../theme';
import TYPE_KEYS from '../consts';
import { sendNewCertToBackend, sendNewSkillToBackend } from '../reducer';

const AddNewSkillOrCertModal = ({ type, setTypeOpen }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [isEntryValid, setIsEntryValid] = useState(false);
  const handleClose = () => {
    setTypeOpen(null);
  };

  const handleInputChange = (event) => {
    setName(event.target.value);
    if (name && name.length >= 0) {
      setIsEntryValid(true);
    } else setIsEntryValid(false);
  };

  const handleAddSkillOrCert = () => {
    if (!name || name.length === 0) {
      setIsEntryValid(false);
      return;
    }

    if (type === TYPE_KEYS.SKILL) {
      dispatch(
        sendNewSkillToBackend({
          name: name.trim(),
          duration: 864000000,
          description: TYPE_KEYS.SKILL,
        })
      );
      return;
    }

    if (type === TYPE_KEYS.CERT) {
      dispatch(
        sendNewCertToBackend({
          fields: {
            name: name.trim(),
            description: TYPE_KEYS.CERT,
          },
        })
      );
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    backgroundColor: theme.skillsAndCerts.palette.modalBgColor,
    border: `2px solid ${theme.skillsAndCerts.palette.modalBorder}`,
    borderRadius: '16px',
    boxShadow: 24,
    p: 4,
    padding: theme.spacing(5),
  };

  return (
    <div>
      <Modal
        open
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            sx={{
              fontSize: theme.skillsAndCerts.typography.modalHeader.fontSize,
              fontFamily: theme.skillsAndCerts.typography.modalHeader.fontFamily,
              color: theme.skillsAndCerts.palette.modalHeader,
            }}
          >
            {type === TYPE_KEYS.SKILL
              ? LanguageConverter('create.skill.header')
              : LanguageConverter('create.cert.header')}
          </Typography>
          <TextField
            sx={{
              backgroundColor: theme.skillsAndCerts.palette.newTextBgColor,
              borderRadius: '40px',
              display: 'flex',
              padding: '8px 16px',
              margin: theme.spacing(2, 0, 5, 0),
              alignItems: 'flex-start',
            }}
            value={name}
            onChange={handleInputChange}
            placeholder={`Enter New ${type}...`}
            variant="standard"
            InputProps={{
              disableUnderline: true,
              sx: {
                width: '100%',
                '&::placeholder': {
                  fontFamily: theme.skillsAndCerts.typography.placeholder.fontFamily,
                  fontSize: theme.skillsAndCerts.typography.placeholder.fontSize,
                },
              },
            }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <WaeButton
              text={LanguageConverter('buttonText.goBack')}
              variant={BUTTON_VARIANT.OUTLINED}
              onClick={() => handleClose()}
              sx={{ marginRight: theme.spacing(1) }}
            />
            <WaeButton
              text={
                type === TYPE_KEYS.SKILL
                  ? LanguageConverter('create.skill.button')
                  : LanguageConverter('create.cert.button')
              }
              onClick={handleAddSkillOrCert}
              disabled={!isEntryValid}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

AddNewSkillOrCertModal.propTypes = {
  setTypeOpen: PropTypes.func,
  type: PropTypes.string,
};

export default AddNewSkillOrCertModal;
